import { render } from "./CalendarPeriod.vue?vue&type=template&id=b0fc2c56"
import script from "./CalendarPeriod.vue?vue&type=script&lang=js"
export * from "./CalendarPeriod.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/app/app/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__